<h2>
  {{ formTitle }}
  <span *ngIf="model.Id" title="CHI Provider Id">- {{ model.Id }}</span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<form
  (ngSubmit)="onSubmit()"
  #editProviderForm="ngForm"
  class="editForm"
  novalidate
  [ngBusy]="busy"
>
  <div class="row">
    <div class="col-md-12">
      <tabset>
        <tab
          heading="Demographics"
          (selectTab)="onTabSelect('Demographics')"
          [active]="selectedTab === 'Demographics'"
        >
          <br />
          <app-providers-edit-demographics
            #demographics
            [model]="model"
          ></app-providers-edit-demographics>
        </tab>
        <ng-container *ngIf="hasSystemManagementPermission()">
          <tab
            heading="Contacts"
            [disabled]="!model.Id"
            (selectTab)="onTabSelect('Contacts')"
            [active]="selectedTab === 'Contacts'"
          >
            <br />
            <app-providers-edit-contacts #contacts [model]="model"></app-providers-edit-contacts>
          </tab>
        </ng-container>
        <ng-container *ngIf="hasSystemManagementPermission()">
          <tab
            heading="835 EDI Configurations"
            [disabled]="!model.Id"
            (selectTab)="onTabSelect('EdiConfigurations')"
            [active]="selectedTab === 'EdiConfigurations'"
          >
            <br />
            <app-providers-edit-edi-config #ediConfigurations [model]="model">
            </app-providers-edit-edi-config>
          </tab>
        </ng-container>
        <tab
          heading="Coverages"
          [disabled]="!model.Id"
          (selectTab)="onTabSelect('Coverages')"
          [active]="selectedTab === 'Coverages'"
        >
          <app-providers-edit-coverages #coverages [model]="model"> </app-providers-edit-coverages>
        </tab>
      </tabset>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <hr />
      <button class="btn btn-default pull-right" type="button" (click)="backToList()">
        Back to list
      </button>
      <button
        type="submit"
        class="btn btn-success pull-right"
        style="margin-right: 15px"
        *ngIf="tabSettings[selectedTab].showSave"
      >
        Save
      </button>
    </div>
  </div>
</form>
